export default {
  'page.userCenter.orderDetail': 'Order Detail',
  'page.userCenter.myOrder': 'My Order',
};
